query getPersonAvatar($aggregateId: String!) {
  personAvatar: getPerson(aggregateId: $aggregateId) {
    aggregateId
    userAvatarOriginal
    userAvatarCropped
    userAvatarCropData {
      x
      y
      width
      height
    }
  }
}
